export enum ExecutionLocationType {
    Local = 'local',
    Cloud = 'cloud',
}
